/**
 * Small DOM + color helpers shared across templates.
 */

export function el(tag, props = {}, ...children) {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(props)) {
    if (k === 'style' && typeof v === 'object') {
      // setProperty handles CSS custom properties (--foo); plain assignment drops them.
      for (const [sk, sv] of Object.entries(v)) {
        if (sk.startsWith('--')) node.style.setProperty(sk, sv);
        else node.style[sk] = sv;
      }
    }
    else if (k === 'dataset' && typeof v === 'object') Object.assign(node.dataset, v);
    else if (k in node) node[k] = v;
    else node.setAttribute(k, v);
  }
  for (const c of children) {
    if (c == null) continue;
    node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
  }
  return node;
}

export function isDarkHex(hex) {
  const h = hex.replace('#', '');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 < 128;
}

/**
 * A standard cleanup tracker — collects unsubscribe functions, runs them all on destroy.
 */
export function createDisposer() {
  const fns = [];
  return {
    add(fn) { if (typeof fn === 'function') fns.push(fn); },
    run() {
      while (fns.length) {
        try { fns.pop()(); } catch (e) { console.warn('[disposer]', e); }
      }
    },
  };
}
